module.exports = __webpack_public_path__ + "img/text.036727a9.webp";